// extracted by mini-css-extract-plugin
export var emailBlockLink = "_n0-0";